export const INQUIRY_PRICE = 3300;